import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { replaceCommaAndParseFloatOrNull } from '~/assets/helper/functions';
import { useRealUserIsIxAdmin } from '~/functions/impact-locking';
import { MetricValueKind } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'SingleValue',
  props: {
    metric: null,
    value: null,
    type: null,
    label: null,
    disabled: {
      type: Boolean
    },
    timeout: null
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var form = ref();
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var isTypeLocked = computed(function () {
      var _props$value, _props$value2;
      if (props.type === 'target') return Boolean((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.targetLocked);
      if (props.type === 'actual') return Boolean((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.actualLocked);
      return false;
    });
    var disabledLocal = computed(function () {
      var _props$value3;
      return props.disabled || ((_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.editable) === false || isTypeLocked.value && !realUserIsIxAdmin.value;
    });
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var valueType = computed(function () {
      return props.metric.valueType;
    });
    var hint = computed(function () {
      return props.metric.isComputed ? proxy.$t('computedMetric') : '';
    });
    var integerRules = [function (v) {
      return isIntegerOrEmpty(v) || proxy.$t('integerWarning') + proxy.$t('notSaved');
    }];
    var floatRules = [function (v) {
      return isNumberOrEmpty(v) || proxy.$t('numberWarning') + proxy.$t('notSaved');
    }];
    var stringToArray = function stringToArray(val) {
      if (typeof val === 'string') {
        return [val];
      } else if (Array.isArray(val)) {
        // value is stored as a {value: 'foo'}
        return val.map(function (e) {
          return (e === null || e === void 0 ? void 0 : e.value) || e;
        });
      } else if (val !== null && val !== void 0 && val.value) {
        return [val.value]; // single select
      }
      return val;
    };
    var matchesNumberFormat = function matchesNumberFormat(str) {
      return /^-?[0-9]*[.,]?[0-9]*$/.test(str);
    };
    var isNumberOrEmpty = function isNumberOrEmpty(str) {
      return !str || matchesNumberFormat(str);
    };
    var isIntegerOrEmpty = function isIntegerOrEmpty(str) {
      return !str || matchesNumberFormat(str) && Number.isInteger(replaceCommaAndParseFloatOrNull(str));
    };
    var handleInput = function handleInput(key, val) {
      var valid = form.value.validate();
      if (valid) {
        var input = {
          metricAssignmentId: props.value.metricAssignmentId,
          period: props.value.period
        };
        input[key] = val;
        emit('input', input);
      }
      // if invalid we don't propagate the input, so on save this field will not be saved. propagating the "valid" status to the parents turned out to be fairly complex and ugly due to the different cases for reportingPeriodType and valueType, so preventing the input felt more maintainable
    };
    var handleBinaryToggle = function handleBinaryToggle(selectedValue) {
      var _props$value4;
      var currentValue = (_props$value4 = props.value) === null || _props$value4 === void 0 ? void 0 : _props$value4[props.type];
      var nextValue = currentValue === selectedValue ? null : selectedValue;
      handleInput(props.type, nextValue);
    };
    var formatNumber = function formatNumber(val) {
      // this prevents the scientific notation like 1e-7 which is not compatible with our rules for numbers
      return val === null || val === void 0 ? void 0 : val.toLocaleString('en-US', {
        useGrouping: false,
        // Disables thousand separators
        minimumFractionDigits: 0,
        maximumFractionDigits: 20 // Adjust based on the precision needed
      });
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      form: form,
      realUserIsIxAdmin: realUserIsIxAdmin,
      isTypeLocked: isTypeLocked,
      disabledLocal: disabledLocal,
      proxy: proxy,
      valueType: valueType,
      hint: hint,
      integerRules: integerRules,
      floatRules: floatRules,
      stringToArray: stringToArray,
      matchesNumberFormat: matchesNumberFormat,
      isNumberOrEmpty: isNumberOrEmpty,
      isIntegerOrEmpty: isIntegerOrEmpty,
      handleInput: handleInput,
      handleBinaryToggle: handleBinaryToggle,
      formatNumber: formatNumber,
      MetricValueKind: MetricValueKind
    };
  }
});